

<div class="page" (window:scroll)="onPageScroll()">
     @if (wallpaperUrl()) {
          <div class="wallpaper-bg" [ngStyle]="{'background-image': wallpaperUrl() ? 'url(' + wallpaperUrl() + ')' : null}">
          </div>
     }
     <div class="top-header" #titleHeader [class.bar-stuck]="isBarStuck()">
          <div class="line">
               <h5>{{currentSuperSection()?.name}}</h5>
               <div class="icon-btns">
                    <img class="icon-xl" [src]="'search.svg' | themeSource" alt="search" (click)="toggleSearch()" />
                    @if (hasFilters()) {
                         <img class="icon-xl" (click)="openFilters()" [src]="(!hasActiveFilters() ? 'filters.svg': 'active-filters.svg') | themeSource" />
                    }
                    @if (hasMultipleCurrencies() || hasMultipleLanguages()) {
                         <img class="icon-xl" data-testid="menu-list-settings" (click)="openSettings()" [src]="(hasMultipleCurrencies() ? 'language-currency.svg' : 'language.svg') | themeSource" alt="settings" />
                    }
                    @if (isUserSelectDisplayMode()) {
                         <img class="icon-xxl" (click)="isGridView.set(!isGridView())" [src]="(!isGridView() ? 'list-select.svg' : 'grid-select.svg') | themeSource" />
                    }
               </div>
          </div>

          <div class="search-box-container" [class.open]="isSearchOpen()">
               <div class="search-box">
                    <mat-icon>search</mat-icon>
                    <input
                         #searchInput
                         type="text"
                         placeholder="{{ 'MENU.SEARCH' | translate }}"
                         [value]="searchQuery()"
                         (input)="searchQuery.set($event.target.value)"
                    >
                    <img class="icon-xl" (click)="closeSearch()" [src]="'close.svg' | themeSource" alt="close" />
               </div>
          </div>
     </div>

     <app-banner [sectionBannerUrl]="currentSuperSection()?.banner_url"></app-banner>

     <div class="sticky-header" #bar [class.stuck]="isBarStuck()" [style.top.px]="titleHeaderHeight() - 1">
          <app-cart-block #cartBlock></app-cart-block>

          <app-combo-guide-block [clickable]="true" (messageClick)="onComboGuideMessageClick($event)"></app-combo-guide-block>

          @if (showSectionScroll()) {
               <div>
                    <ul class="section-scroll" #sectionScroll>
                         @for (section of visibleSubSections(); track section.id) {
                              <li
                                   class="capital"
                                   [attr.data-section-id]="section.id"
                                   (click)="selectSubSection(section.id)"
                                   [ngClass]="{'selected': section.id === selectedSubSectionId()}">
                                        {{ section.name | titlecase }}
                              </li>
                         }
                    </ul>
               </div>
          }

          
     </div>
     
     <div class="pad">
          @if (searchQuery()) {
               @if (searchResults().length) {
                    <div [class.items-grid]="isGridView()">
                         @for (result of searchResults(); track result.item.id + (result.subSectionId ?? '')) {
                              <app-item [item]="result.item" [class.highlight]="result.item.highlight" [isGridView]="isGridView()" [subSectionId]="result.subSectionId" [isOptionalSubSection]="result.isOptionalSubSection"></app-item>
                         }
                    </div>
               } @else if (matchingSuperSections().length) {
                    <h5 class="upper">{{ 'MENU.SEARCH_OTHER_SECTIONS' | translate }}</h5>
                    @if (isGridLayout()) {
                         <app-super-section-scroll [sections]="matchingSuperSections()" mode="slider"></app-super-section-scroll>
                    } @else {
                         <app-super-section-list [sections]="matchingSuperSections()"></app-super-section-list>
                    }
               } @else {
                    <app-search-empty-state></app-search-empty-state>
               }
          } @else {
               @if (superSectionDescription(); as description) {
                    <h6 class="desc">{{ description }}</h6>
               }

               @if (isFilteredEmpty()) {
                    <app-search-empty-state icon="filter_alt_off" message="MENU.NO_FILTER_RESULTS" actionLabel="MENU.CLEAR_FILTERS" (action)="clearFilters()"></app-search-empty-state>
               } @else {
                    @if (directItems().length) {
                         <div [class.items-grid]="isGridView()">
                              @for (item of directItems(); track item.id) {
                                   <app-item [item]="item" [class.highlight]="item.highlight" [isGridView]="isGridView()"></app-item>
                              }
                         </div>
                    }
                    @for (section of visibleSubSections(); track section.id) {
                         <div class="sub-head upper" [id]="'sub-section-' + section.id">
                              <h4>
                                   {{ section.name }}

                              </h4>
                              @if (section.required) {
                                   <div class="required-tag">
                                        <span>{{ 'COMMON.REQUIRED' | translate }}</span>
                                   </div>
                              }
                         </div>
                         @if (section.description?.trim()) {
                              <p class="sub-desc">{{ section.description }}</p>
                         }

                         <div [class.items-grid]="isGridView()">
                              @for (item of section.items; track $index) {
                                   <app-item [item]="item" [class.highlight]="item.highlight" [isGridView]="isGridView()" [subSectionId]="section.id" [isOptionalSubSection]="!section.required"></app-item>
                              }
                         </div>
                    }

                    @if (menuDescription(); as description) {
                         <h6 class="desc menu-desc">{{ description }}</h6>
                    }
               }
          }
     </div>

     <app-bottom-bar></app-bottom-bar>

</div>